import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sentGAEvent from "@/ga";
import Utils from '@/utils/index'
import { ReactComponent as Close } from "@/assets/images/moblieClose.svg";
import "@/assets/fixedMessage.less";
class FixMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        
    };
  }

  close = () => {
    this.props.onCancel()
  }
  
  mobileLearnMore = () => {
    this.props.onCancel()
    window.open(Utils.getHitPawConvertSeoLink())
  }

  render() {
    const { t } = this.props;
    const { productIntrInfoList,text } = this.state;
    return (
    <div>
        {
            this.props.visible?(
                <div class="fixed-container">
                { t(this.props.content) }
                <span v-if="isShowMore" style={{color: "#6b57ff",textDecoration: "underline",}} onClick={this.mobileLearnMore}>{
                    t('Learn more')
                }</span><Close onClick={this.close} style={{ position: 'absolute',
                    top: '-0.6rem',
                    right: '-0.2222rem', }}/>
                </div>
            ):null
        }
        </div>
    );
  }
}
export default withTranslation(["common"])(FixMessage);